import { Controller } from "@hotwired/stimulus"

// Single search input + chips list for event guests. When user is selected from search, add as chip.
export default class extends Controller {
  static targets = ["selectedContainer", "chipTemplate"]

  connect() {
    this.boundHandleGuestSelected = this.handleGuestSelected.bind(this)
    this.element.addEventListener("user-search:guest-selected", this.boundHandleGuestSelected)
  }

  disconnect() {
    this.element.removeEventListener("user-search:guest-selected", this.boundHandleGuestSelected)
  }

  handleGuestSelected(event) {
    const { userId, userName } = event.detail
    if (!userId || !userName) return
    if (this.hasSelectedContainerTarget) {
      if (this.selectedContainerTarget.querySelector(`input[value="${userId}"]`)) return
      const chip = this.createChip(userId, userName)
      if (chip) this.selectedContainerTarget.appendChild(chip)
    }
  }

  createChip(userId, userName) {
    const template = this.hasChipTemplateTarget ? this.chipTemplateTarget : this.element.querySelector("template#user-chip-template")
    if (!template || !template.content) {
      return this.createChipFallback(userId, userName)
    }
    const clone = template.content.cloneNode(true)
    const chip = clone.querySelector("[data-lesson-guest-selector-target='chip']") || clone.firstElementChild
    const avatarEl = chip?.querySelector("[data-lesson-guest-selector-target='chipAvatar']")
    const labelEl = chip?.querySelector("[data-lesson-guest-selector-target='chipLabel']")
    const inputEl = chip?.querySelector("[data-lesson-guest-selector-target='chipInput']") || chip?.querySelector("input[name='user_ids[]']")
    if (avatarEl) avatarEl.textContent = (userName || "").charAt(0).toUpperCase()
    if (labelEl) labelEl.textContent = userName
    if (inputEl) inputEl.value = userId
    if (chip) chip.dataset.userId = userId
    return chip
  }

  createChipFallback(userId, userName) {
    const initial = (userName || "").charAt(0).toUpperCase()
    const wrapper = document.createElement("div")
    wrapper.className = "inline-flex items-center gap-2 rounded-full bg-background-light px-3 py-1.5 text-sm text-primary-color border border-input-border-color"
    wrapper.dataset.userId = userId
    wrapper.innerHTML = `
      <span class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary-light-color/20 text-xs font-medium text-primary-color">${this.escapeHtml(initial)}</span>
      <span>${this.escapeHtml(userName)}</span>
      <button type="button" aria-label="Quitar" class="hover:text-button-danger-bg rounded-full p-0.5" data-action="click->lesson-guest-selector#removeChip">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
      <input type="hidden" name="user_ids[]" value="${this.escapeHtml(userId)}">
    `
    return wrapper
  }

  removeChip(event) {
    const button = event.currentTarget
    const chip = button.closest("[data-user-id]")
    if (chip) chip.remove()
  }

  escapeHtml(str) {
    const div = document.createElement("div")
    div.textContent = str
    return div.innerHTML
  }
}
